(function () {
  var videoSelector = '[data-product-gallery-video]';
  var initializedAttribute = 'data-product-gallery-video-initialized';
  var activeClass = 'product-gallery-video--playing';
  var controlsVisibleClass = 'product-gallery-video--controls-visible';
  var userPlayedClass = 'product-gallery-video--user-played';
  var autoplayVisibilityThreshold = 0.2;
  var updateFrame = null;

  function isAutoplayEnabled(container) {
    return container.dataset.autoplay === 'true';
  }

  function isPriority(container) {
    return container.dataset.priority === 'true';
  }

  function getPlayer(container) {
    return container.querySelector('[data-product-gallery-video-player]');
  }

  function isHosted(container) {
    return container.dataset.productGalleryVideoType === 'hosted';
  }

  function loadMedia(container) {
    if (container.dataset.loaded === 'true') return false;

    var player = getPlayer(container);
    if (!player) return false;

    if (isHosted(container)) {
      player.querySelectorAll('source[data-src]').forEach(function (source) {
        source.src = source.dataset.src;
        source.removeAttribute('data-src');
      });
      player.load();
    } else if (player.dataset.src) {
      player.src = player.dataset.src;
      player.removeAttribute('data-src');
    }

    container.dataset.loaded = 'true';
    return true;
  }

  function setPlayingState(container, isPlaying) {
    container.classList.toggle(activeClass, isPlaying);
    if (!isPlaying) {
      clearControlsTimer(container);
      container.classList.remove(controlsVisibleClass);
    }
  }

  function pauseSiblingVideos(container) {
    var product = container.closest('.product');
    var scope = product || document;

    scope.querySelectorAll(videoSelector).forEach(function (otherContainer) {
      if (otherContainer !== container) {
        pauseMedia(otherContainer);
      }
    });
  }

  function postExternalCommand(player, provider, command) {
    if (!player || !player.contentWindow) return;

    if (provider === 'vimeo') {
      var vimeoMethod = command === 'playVideo' ? 'play' : command === 'pauseVideo' ? 'pause' : 'setMuted';
      player.contentWindow.postMessage(
        JSON.stringify({
          method: vimeoMethod,
          value: command === 'mute' ? true : undefined
        }),
        '*'
      );
      return;
    }

    player.contentWindow.postMessage(
      JSON.stringify({
        event: 'command',
        func: command,
        args: []
      }),
      '*'
    );
  }

  function getExternalProvider(player) {
    var src = player ? player.src || player.dataset.src || '' : '';
    return src.indexOf('vimeo') !== -1 ? 'vimeo' : 'youtube';
  }

  function playMedia(container, options) {
    var player = getPlayer(container);
    if (!player) return;

    var settings = options || {};
    var loadedNow = loadMedia(container);
    pauseSiblingVideos(container);

    if (isHosted(container)) {
      player.muted = true;
      player.controls = false;
      player.playsInline = true;

      var playPromise = player.play();
      if (playPromise && playPromise.catch) {
        playPromise.catch(function () {
          setPlayingState(container, false);
        });
      }
    } else {
      var provider = getExternalProvider(player);
      var playExternal = function () {
        postExternalCommand(player, provider, 'mute');
        postExternalCommand(player, provider, 'playVideo');
      };

      if (loadedNow) {
        player.addEventListener('load', playExternal, { once: true });
      } else {
        playExternal();
      }
    }

    setPlayingState(container, true);

    if (settings.showControls) {
      showControlsTemporarily(container);
    }
  }

  function clearControlsTimer(container) {
    if (container.productGalleryVideoControlsTimer) {
      window.clearTimeout(container.productGalleryVideoControlsTimer);
      container.productGalleryVideoControlsTimer = null;
    }
  }

  function showControlsTemporarily(container) {
    clearControlsTimer(container);
    container.classList.add(controlsVisibleClass);

    if (!container.classList.contains(activeClass)) return;

    container.productGalleryVideoControlsTimer = window.setTimeout(function () {
      container.classList.remove(controlsVisibleClass);
      container.productGalleryVideoControlsTimer = null;
    }, 1200);
  }

  function toggleMedia(container) {
    var player = getPlayer(container);
    if (!player) return;

    container.classList.add(userPlayedClass);

    if (isHosted(container)) {
      if (player.paused) {
        playMedia(container, { showControls: true });
      } else {
        pauseMedia(container);
        container.classList.add(controlsVisibleClass);
      }
      return;
    }

    if (container.classList.contains(activeClass)) {
      pauseMedia(container);
      container.classList.add(controlsVisibleClass);
    } else {
      playMedia(container, { showControls: true });
    }
  }

  function pauseMedia(container) {
    var player = getPlayer(container);
    if (!player) return;

    if (isHosted(container)) {
      player.pause();
    } else {
      postExternalCommand(player, getExternalProvider(player), 'pauseVideo');
    }

    setPlayingState(container, false);
  }

  function isRenderable(element) {
    return !!(element.offsetWidth || element.offsetHeight || element.getClientRects().length);
  }

  function isMobileGallery(container) {
    return !!container.closest('.product__media-container.below-mobile');
  }

  function isActiveMobileSlide(container) {
    var slide = container.closest('.swiper-slide');
    return !slide || slide.classList.contains('swiper-slide-active');
  }

  function getAutoplayScope(container) {
    return container.closest('.product__media-container') || container.closest('.product') || document.body;
  }

  function getVisibleRatio(container) {
    if (!isRenderable(container)) return 0;

    var rect = container.getBoundingClientRect();
    var viewportWidth = window.innerWidth || document.documentElement.clientWidth;
    var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    var width = rect.width || rect.right - rect.left;
    var height = rect.height || rect.bottom - rect.top;

    if (width <= 0 || height <= 0) return 0;

    var visibleWidth = Math.max(0, Math.min(rect.right, viewportWidth) - Math.max(rect.left, 0));
    var visibleHeight = Math.max(0, Math.min(rect.bottom, viewportHeight) - Math.max(rect.top, 0));
    var visibleArea = visibleWidth * visibleHeight;

    return visibleArea / (width * height);
  }

  function getAutoplayScore(container) {
    if (!isAutoplayEnabled(container)) return 0;
    if (!isRenderable(container)) return 0;

    if (isMobileGallery(container) && !isActiveMobileSlide(container)) {
      return 0;
    }

    var visibleRatio = getVisibleRatio(container);
    return visibleRatio >= autoplayVisibilityThreshold ? visibleRatio : 0;
  }

  function updateAutoplayState() {
    var candidatesByScope = new Map();

    document.querySelectorAll(videoSelector).forEach(function (container) {
      if (!isAutoplayEnabled(container)) return;

      var score = getAutoplayScore(container);

      if (!score) {
        pauseMedia(container);
        return;
      }

      var scope = getAutoplayScope(container);
      var current = candidatesByScope.get(scope);

      if (!current || score > current.score) {
        candidatesByScope.set(scope, {
          container: container,
          score: score
        });
      }
    });

    candidatesByScope.forEach(function (candidate, scope) {
      scope.querySelectorAll(videoSelector).forEach(function (container) {
        if (!isAutoplayEnabled(container)) return;

        if (container === candidate.container) {
          playMedia(container, { showControls: false });
        } else {
          pauseMedia(container);
        }
      });
    });
  }

  function scheduleUpdate() {
    if (updateFrame) return;

    updateFrame = window.requestAnimationFrame(function () {
      updateFrame = null;
      updateAutoplayState();
    });
  }

  function observeSlideClass(container) {
    if (!('MutationObserver' in window)) return;

    var slide = container.closest('.swiper-slide');
    if (!slide || slide.productGalleryVideoClassObserver) return;

    slide.productGalleryVideoClassObserver = new MutationObserver(scheduleUpdate);
    slide.productGalleryVideoClassObserver.observe(slide, {
      attributes: true,
      attributeFilter: ['class']
    });
  }

  function initVideo(container) {
    if (container.hasAttribute(initializedAttribute)) return;
    container.setAttribute(initializedAttribute, 'true');

    var player = getPlayer(container);
    if (!player) return;

    if (isHosted(container)) {
      player.muted = true;
      player.controls = false;
      player.playsInline = true;

      player.addEventListener('play', function () {
        player.muted = true;
        player.controls = false;
        setPlayingState(container, true);
      });

      player.addEventListener('pause', function () {
        setPlayingState(container, false);
      });

      player.addEventListener('ended', function () {
        if (isAutoplayEnabled(container)) {
          playMedia(container, { showControls: false });
        } else {
          setPlayingState(container, false);
        }
      });
    }

    if (isPriority(container)) {
      loadMedia(container);
    }

    observeSlideClass(container);

    var playButton = container.querySelector('[data-product-gallery-video-play]');
    if (playButton) {
      playButton.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        toggleMedia(container);
      });
    }

    container.addEventListener('click', function () {
      if (container.classList.contains(activeClass)) {
        showControlsTemporarily(container);
        return;
      }

      if (isAutoplayEnabled(container)) {
        showControlsTemporarily(container);
      } else {
        toggleMedia(container);
      }
    });
  }

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll(videoSelector).forEach(initVideo);
    scheduleUpdate();
  }

  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(scheduleUpdate, {
      threshold: [0, autoplayVisibilityThreshold, 0.5, 0.85]
    });

    var observeInitialized = function () {
      document.querySelectorAll(videoSelector).forEach(function (container) {
        observer.observe(container);
      });
      scheduleUpdate();
    };

    document.addEventListener('DOMContentLoaded', observeInitialized);
    document.addEventListener('shopify:section:load', observeInitialized);
  }

  document.addEventListener('DOMContentLoaded', function () {
    init(document);
    window.addEventListener('resize', scheduleUpdate, { passive: true });
    window.addEventListener('scroll', scheduleUpdate, { passive: true });
  });

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
